import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
// import { CALC_ROUTES } from '../App';
import { CALC_ROUTES } from '../config/Calc_Routes';

export default function Header() {
  const { dark, toggle } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();
  const isHome = loc.pathname === '/';
  const close = () => { setMenuOpen(false); setMobileOpen(false); };

  const hdrStyle = {
    background: 'var(--header-bg)', backdropFilter: 'blur(20px)',
    borderBottom: '1px solid var(--border)', position: 'sticky',
    top: 0, zIndex: 200, transition: 'background 0.3s',
  };
  const innerStyle = {
    maxWidth: '1400px', margin: '0 auto', padding: '0 16px',
    display: 'flex', alignItems: 'center', height: '60px', gap: '10px',
  };
  const iconBtn = (extra = {}) => ({
    flexShrink: 0, width: '36px', height: '36px', borderRadius: '10px',
    background: 'var(--toggle-bg)', border: '1px solid var(--border)',
    color: 'var(--t2)', cursor: 'pointer', display: 'flex',
    alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', ...extra,
  });

  return (
    <>
      <header style={hdrStyle}>
        
        <div style={innerStyle}>
          {/* Back Button */}
          {/* {!isHome && (
            <button onClick={() => nav(-1)} title="Go back" style={iconBtn({ fontSize: '18px' })}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--orange)'; e.currentTarget.style.color = 'var(--orange)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--t2)'; }}>
              ‹
            </button>
          )} */}

          {/* Logo */}
          <Link to="/" onClick={close} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '9px', flexShrink: 0 }}>
            <div style={{ width: '34px', height: '34px', background: 'linear-gradient(135deg,var(--orange),var(--orange2))', borderRadius: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', boxShadow: '0 3px 12px rgba(255,107,44,0.35)' }}>🧮</div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 800, fontSize: '16px', lineHeight: 1, color: 'var(--t1)' }}>
                Apnaa <span style={{ color: 'var(--orange)' }}>Calculator</span>
              </span>
              <span style={{ fontSize: '9px', color: 'var(--t3)', lineHeight: 1, marginTop: '2px' }}>India's #1 Financial Calculator</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav style={{ display: 'flex', gap: '2px', flex: 1, justifyContent: 'center' }} className="hide-mobile">
            {[['Home', '/'], ['EMI', '/emi'], ['SIP', '/sip'], ['Tax', '/income-tax'], ['GST', '/gst'], ['FD', '/fd']].map(([n, p]) => (
              <Link key={p} to={p} style={{ padding: '6px 11px', borderRadius: '8px', textDecoration: 'none', fontSize: '13px', fontWeight: 600, color: loc.pathname === p ? 'var(--orange)' : 'var(--t2)', background: loc.pathname === p ? 'rgba(255,107,44,0.1)' : 'transparent', transition: 'all 0.18s' }}
                onMouseEnter={e => { if (loc.pathname !== p) e.currentTarget.style.color = 'var(--t1)'; }}
                onMouseLeave={e => { if (loc.pathname !== p) e.currentTarget.style.color = 'var(--t2)'; }}>{n}
              </Link>
            ))}
          </nav>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 'auto' }}>
            {/* Theme Toggle */}
            <button onClick={toggle} title={dark ? 'Light Mode' : 'Dark Mode'} style={iconBtn({ fontSize: '16px' })}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--orange)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}>
              {dark ? '☀️' : '🌙'}
            </button>

            {/* Desktop All Calculators */}
            <button className="hide-mobile" onClick={() => setMenuOpen(o => !o)} style={{ background: menuOpen ? 'rgba(255,107,44,0.12)' : 'var(--card)', border: `1px solid ${menuOpen ? 'var(--orange)' : 'var(--border)'}`, borderRadius: '10px', padding: '7px 13px', color: menuOpen ? 'var(--orange)' : 'var(--t2)', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter,sans-serif', flexShrink: 0, transition: 'all 0.18s' }}>
              ☰ All 30+
            </button>

            {/* Mobile Hamburger */}
            <button className="show-mobile" onClick={() => setMobileOpen(o => !o)} style={iconBtn({ fontSize: '18px', color: mobileOpen ? 'var(--orange)' : 'var(--t2)', borderColor: mobileOpen ? 'var(--orange)' : 'var(--border)' })}>
              {mobileOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>
      </header>

      {/* Desktop Mega Menu */}
      {menuOpen && (
        <div style={{ position: 'fixed', top: '60px', left: 0, right: 0, background: 'var(--header-bg)', backdropFilter: 'blur(20px)', borderBottom: '1px solid var(--border)', zIndex: 198, maxHeight: '80vh', overflowY: 'auto' }} onClick={close}>
          <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px 16px' }}>
            {Object.entries(CALC_ROUTES).map(([cat, items]) => (
              <div key={cat} style={{ marginBottom: '16px' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>{cat}</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(195px,1fr))', gap: '5px' }}>
                  {items.map(item => (
                    <Link key={item.path} to={item.path} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 11px', borderRadius: '10px', textDecoration: 'none', color: 'var(--t2)', fontSize: '13px', fontWeight: 500, transition: 'all 0.18s', border: '1px solid transparent' }}
                      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,107,44,0.07)'; e.currentTarget.style.color = 'var(--t1)'; e.currentTarget.style.borderColor = 'rgba(255,107,44,0.2)'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--t2)'; e.currentTarget.style.borderColor = 'transparent'; }}>
                      <span style={{ fontSize: '15px' }}>{item.icon}</span>{item.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
            {/* <div style={{ borderTop: '1px solid var(--border)', paddingTop: '12px', marginTop: '4px' }}>
              <Link to="/admin" onClick={close} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '8px 14px', borderRadius: '10px', textDecoration: 'none', background: 'rgba(176,110,243,0.1)', border: '1px solid rgba(176,110,243,0.3)', color: 'var(--purple)', fontSize: '13px', fontWeight: 600 }}>
                ⚙️ SEO Admin Panel
              </Link>
            </div> */}
          </div>
        </div>
      )}

      {/* Mobile Drawer */}
      {mobileOpen && (
        <div style={{ position: 'fixed', top: '60px', left: 0, right: 0, bottom: 0, background: 'var(--bg)', zIndex: 197, overflowY: 'auto', padding: '16px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '20px' }}>
            {[['🏠', 'Home', '/']
              //  ['🔐', 'Admin', '/admin']
            ].map(([ic, n, p]) => (
              <Link key={p} to={p} onClick={close} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', borderRadius: '12px', textDecoration: 'none', color: 'var(--t1)', fontSize: '14px', fontWeight: 700, background: 'var(--card)', border: `1px solid ${loc.pathname === p ? 'var(--orange)' : 'var(--border)'}` }}>
                <span>{ic}</span>{n}
              </Link>
            ))}
          </div>
          {Object.entries(CALC_ROUTES).map(([cat, items]) => (
            <div key={cat} style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '11px', fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '8px', padding: '0 2px' }}>{cat}</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '7px' }}>
                {items.map(item => (
                  <Link key={item.path} to={item.path} onClick={close} style={{ padding: '11px 12px', borderRadius: '11px', textDecoration: 'none', background: 'var(--card)', border: `1px solid ${loc.pathname === item.path ? 'var(--orange)' : 'var(--border)'}`, display: 'flex', alignItems: 'center', gap: '7px' }}>
                    <span style={{ fontSize: '17px' }}>{item.icon}</span>
                    <span style={{ fontSize: '11.5px', fontWeight: 600, color: 'var(--t1)', lineHeight: 1.3 }}>{item.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
